<template>
    <div>
        <Title :title="$t('MATRICULAS.CONTATOS')" />
        <b-table
            :items="contatos"
            :fields="tabela.fields"
            :empty-text="$t('GERAL.NENHUM_REGISTRO')"
            head-variant="light"
            stacked="md"
            show-empty
            responsive
            striped
            hover
        />
    </div>
</template>
<script>
import Title from '@/components/Title';

export default {
    props: ['contatos'],
    components: { Title },
    data() {
        return {
            tabela: {
                fields: [
                    {
                        key: 'descricao',
                        label: this.$t('MATRICULAS.DESCRICAO'),
                        sortable: true,
                    },
                    {
                        key: 'tipoContatoDescricao',
                        label: this.$t('MATRICULAS.TIPO_CONTATO'),
                        sortable: true,
                    },
                    {
                        key: 'principal',
                        label: this.$t('MATRICULAS.PRINCIPAL'),
                        sortable: true,
                        formatter: (value) => value ? 'Sim' : 'Não'
                    },
                ],
            },
        };
    },
};
</script>